import React from 'react';
import { ApButtonGroup, ApButtonMain } from '@alixpartners/ui-components';
import {
	Wrapper,
	StyledButtonSecondary,
	StyledModal,
} from '../../Details/ChangeTypeModal/styles';
import { ModalText } from './Bin.styles';

export const RestoreModal = ({
	confirmRestore,
	onClose,
	transactionsAmount,
}) => {
	return (
		<Wrapper onClick={e => e.stopPropagation()}>
			<StyledModal
				isOpen
				header="Restore from bin"
				isDismissible
				hasClosed={onClose}
				footer={({ handleClose }) => {
					return (
						<ApButtonGroup justifyContent="flex-end">
							<StyledButtonSecondary onClick={handleClose}>
								Cancel
							</StyledButtonSecondary>
							<ApButtonMain onClick={confirmRestore}>Restore</ApButtonMain>
						</ApButtonGroup>
					);
				}}
			>
				<ModalText>
					You are about to restore {transactionsAmount} transaction{transactionsAmount >
					1
						? 's'
						: ''}. Are you sure you want to proceed?
				</ModalText>
			</StyledModal>
		</Wrapper>
	);
};

export default RestoreModal;
